/**
 * 에러플로우 정의
 * https://confluence.nexon.com/pages/viewpage.action?pageId=413511577
 */
import ERROR_CODE from '../constants/error-code.enum'

class InfaceAuthError extends Error {
  constructor({ code, name, message, response, data }) {
    super()
    this.code = code
    this.name = name || ERROR_CODE[code]
    this.message = message || (ERROR_CODE[code] && $t(ERROR_CODE[code])) || 'unknown error'
    this.response = response || new Response()
    this.data = data || {}
  }

  getMessageWithCode() {
    return `${this.message} (${this.code})`
  }
}

export default InfaceAuthError